import {CSSProperties, forwardRef, HTMLProps, Ref} from 'react';

interface IProps
  extends Pick<HTMLProps<HTMLDivElement>, 'children' | 'style' | 'className'> {
  aspectRatio: number; // height / width
  bgClassName?: string;
  bgStyle?: CSSProperties;
  wrapperClassName?: string;
  hasSpace?: boolean;
  paddingTop?: string;
}

// padingTop에 %를 사용하면 width를 기준으로 설정이 되어 가로세로 비율을 유지 할 수 있다.
// 참고로 paddingTop이 아니라 height를 사용하면 부모의 높이 기준으로 계산되서 비율을 유지할 수 없다.
//  https://www.w3schools.com/howto/howto_css_aspect_ratio.asp
function AspectRatioBox(
  {
    aspectRatio,
    bgClassName = 'bg-transparent',
    bgStyle,
    children,
    style,
    className,
    wrapperClassName,
    hasSpace,
    paddingTop,
  }: IProps,
  ref: Ref<HTMLDivElement>
) {
  return (
    <div
      ref={ref}
      className={cn('relative w-full', bgClassName, className)}
      style={{...bgStyle, paddingTop: paddingTop || `${aspectRatio * 100}%`}}
    >
      <div
        className={cn(
          'overflow-hidden absolute',
          wrapperClassName,
          hasSpace ? 'inset-2' : 'inset-0'
        )}
        style={style}
      >
        {children}
      </div>
    </div>
  );
}

export default forwardRef(AspectRatioBox);
